import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanhiaAerea, Fatura, InfosCircuito, PoliticaCircuitoRQ, PoliticaCircuitoRS, ReservarCircuitoRQ, Traslado } from 'src/app/model/turismo/circuito.model';
import { CircuitoService } from 'src/app/services';

@Component({
  selector: 'app-circuito-reserva',
  standalone: false,
  templateUrl: './circuito-reserva.component.html',
  styleUrl: './circuito-reserva.component.scss'
})
export class CircuitoReservaComponent implements OnInit {

  @Input() Circuito: any;
  @Output() alterou = new EventEmitter<any>();

  politicaCircuitoRQ: PoliticaCircuitoRQ = new PoliticaCircuitoRQ();
  politicaCircuitoRS: PoliticaCircuitoRS = new PoliticaCircuitoRS();

  liberaConfirmarTrasladoInicio: boolean = false;
  liberaConfirmarTrasladoFim: boolean = false;

  carregando: boolean = false;
  circuitoRetarifado: boolean = false;
  cienteRetarifado: boolean = false;
  reservado: boolean = false;
  liberaConfirmar: boolean = false;
  buscouValor: boolean = false;
  confirmouTrasladoIN: boolean = false;
  confirmouTrasladoOUT: boolean = false;
  confirmouFlexivel: boolean = false;
  permiteReservar: boolean = false;
  buscandoCompanhias: boolean = false;

  noiteInicio: number = 0;
  noiteFim: number = 0;
  arrayNoites: number = 0;

  //ST
  CompanhiasAereas: CompanhiaAerea[] = [];
  companhia: string;
  data: CompanhiaAerea[] = [];
  TrasladoInicio = new Traslado();
  TrasladoFim = new Traslado();
  TrasladoInicioVoo: string;
  TrasladoFimVoo: string;
  TrasladoInicioCompanhia: string;
  TrasladoFimCompanhia: string;

  //EM
  Traslados: Traslado[] = [];

  ValorProdutos: Fatura[] = [];
  mensagensErro: string[] = [];
  mensagensSucesso: string[] = [];

  IncluiTraslados: boolean = false;
  NoitesAdicionais: boolean = false;
  Flexivel: boolean = false;

  CidadeIncorporacao: string;
  DataIncorporacao: string;
  CidadeAbandono: string;
  DataAbandono: string;

  constructor(
    private circuitoService: CircuitoService,
    private modalService: NgbModal,
    private ref: ChangeDetectorRef
    // private confirmacaoService: ConfirmacaoService
  ) {
   }

  ngOnInit() {
    this.politicaCircuitoRQ.Circuito = this.Circuito;
    this.buscarPolitica();
  }

  buscarPolitica() {
    this.mensagensSucesso = [];
    this.mensagensErro = [];
    this.carregando = true;
    this.buscouValor = false;

    console.log("Dados enviados:", this.politicaCircuitoRQ);
    this.circuitoService.politicaCircuito(this.politicaCircuitoRQ).subscribe(
      dados => {
        this.politicaCircuitoRS = dados;
        this.circuitoRetarifado = dados.Retarifado;

        if (this.politicaCircuitoRS.Incorporacoes.length > 0) {
          this.DataIncorporacao = this.politicaCircuitoRS.Incorporacoes[0].Data;
          this.CidadeIncorporacao = this.politicaCircuitoRS.Incorporacoes[0].CidadeNome;
        };

        if (this.politicaCircuitoRS.Abandonos.length > 0) {
          this.DataAbandono = this.politicaCircuitoRS.Abandonos[this.politicaCircuitoRS.Abandonos.length - 1].Data;
          this.CidadeAbandono = this.politicaCircuitoRS.Abandonos[this.politicaCircuitoRS.Abandonos.length - 1].CidadeNome;
        };

        this.politicaCircuitoRQ.Token = dados.Token;
        this.validarTraslados(dados.Traslados);

        this.CompanhiasAereas = dados.Companhias;

        this.salvar(true);
        this.permiteReservar = dados.PermiteReservar;

        if (dados.Circuito.ExigePrePagamento || !this.permiteReservar) {
          alert("Este Circuito Exige Pré-Pagamento Para ser Reservado!");
        }

        this.alterou.emit(dados.Circuito);

        this.carregando = false;
      },
      erro => {
        console.log("Erro ao buscar política:", erro);
        this.mensagensErro = this.errorHandler(erro);
      });
  }

  setFlexIn(event) {
    this.liberaConfirmar = true;
    this.CidadeIncorporacao = this.politicaCircuitoRS.Incorporacoes.find(x => x.Data == event).CidadeNome;
  }

  setFlexOut(event) {
    this.liberaConfirmar = true;
    this.CidadeAbandono = this.politicaCircuitoRS.Abandonos.find(x => x.Data == event).CidadeNome;
  }

  confirmarTraslado(index: number) {
    if (this.Traslados[index].TipoTraslado == "IN") {
      this.Traslados.filter(x => x.TipoTraslado == "IN").forEach(x => x.Confirmado = false);
    } else {
      this.Traslados.filter(x => x.TipoTraslado == "OUT").forEach(x => x.Confirmado = false);
    }
    this.Traslados[index].Confirmado = true;
  }

  confirmarFlexivel() {
    this.carregando = true;
    this.mensagensErro = [];
    this.buscouValor = false;
    this.mensagensSucesso = [];

    this.politicaCircuitoRQ.DataAbandono = this.DataAbandono;
    this.politicaCircuitoRQ.DataIncorporacao = this.DataIncorporacao;
    this.circuitoService.incorporacaoAbandonoCircuito(this.politicaCircuitoRQ).subscribe(
      dados => {
        this.liberaConfirmar = false;
        this.confirmouFlexivel = true;
        this.confirmouTrasladoIN = false;
        this.confirmouTrasladoOUT = false;

        this.politicaCircuitoRS.PermiteNoitesAdicionais = dados.PermiteNoitesAdicionais;
        this.politicaCircuitoRS.IncluiTransladoChegada = dados.IncluiTransladoChegada;
        this.politicaCircuitoRS.IncluiTransladoPartida = dados.IncluiTransladoPartida;
        this.politicaCircuitoRS.NoitesAdicionais = dados.NoitesAdicionais;

        this.validarTraslados(dados.Traslados);
        this.exibirValor();

        if (dados.Erros.length > 0) {
          this.mensagensErro = dados.Erros;
        }

      },
      erro => {
        this.carregando = false;
        this.liberaConfirmar = false;

        this.mensagensErro = this.errorHandler(erro);
        console.log(erro);
      }
    );
  }

  confirmarNoitesAdicionais(event, noiteAdicional) {
    this.mensagensSucesso = [];
    this.mensagensErro = [];
    this.carregando = true;
    this.buscouValor = false;

    this.politicaCircuitoRQ.NoitesAdicionais = event;
    this.politicaCircuitoRQ.NoiteAdicionalServicoId = noiteAdicional.ServicoId;

    this.circuitoService.noitesAdicionaisCircuito(this.politicaCircuitoRQ).subscribe(
      dados => {
        this.politicaCircuitoRS.NoitesAdicionais = dados.NoitesAdicionais;
        this.confirmouTrasladoIN = false;
        this.confirmouTrasladoOUT = false;

        this.validarTraslados(dados.Traslados);
        this.exibirValor();

        if (dados.Erros.length > 0) {
          this.mensagensErro = dados.Erros;
        }
      },
      erro => {
        this.carregando = false;
        this.mensagensErro = this.errorHandler(erro);
        console.log(erro);
      }
    );
  }

  onChangeCompanhia(val: string, inicio = true) {
    this.buscandoCompanhias = true;
    if (inicio) {
      this.liberaConfirmarTrasladoInicio = false;
    } else {
      this.liberaConfirmarTrasladoFim = false;
    }
    this.data = this.CompanhiasAereas.filter(x => x.Iata.toUpperCase().includes(val.toUpperCase()));
    this.data = this.data.map(function (x) {
      x.display_field =
        x.Iata + " / " + x.Nome;
      return x;
    });
  }

  selecionaCompanhia(companhia: CompanhiaAerea, inicio = true) {
    if (companhia.Iata != undefined && companhia.Nome != undefined) {
      this.politicaCircuitoRQ.Companhia = companhia.Iata;
      if (inicio) {
        this.TrasladoInicioCompanhia = companhia.Iata + " / " + companhia.Nome;
        this.liberaConfirmarTrasladoInicio = true;
      } else {
        this.TrasladoFimCompanhia = companhia.Iata + " / " + companhia.Nome;
        this.liberaConfirmarTrasladoFim = true;
      };
    };
    this.buscandoCompanhias = false;
  }

  confirmarTrasladoIN() {
    this.mensagensSucesso = [];
    this.mensagensErro = [];
    this.carregando = true;
    this.buscouValor = false;

    this.politicaCircuitoRQ.VooNumero = this.TrasladoInicioVoo;
    this.politicaCircuitoRQ.TrasladoServicoId = this.TrasladoInicio.ServicoId;

    this.circuitoService.trasladosCircuito(this.politicaCircuitoRQ).subscribe(
      dados => {
        this.liberaConfirmarTrasladoInicio = false;
        this.confirmouTrasladoIN = true;

        if (dados.Erros.length > 0) {
          this.mensagensErro = dados.Erros;
          this.TrasladoInicioCompanhia = "";
          this.TrasladoInicioVoo = "";
        } else {
          this.validarTraslados(dados.Traslados);
        }

        this.carregando = false;
      },
      erro => {
        this.carregando = false;
        this.liberaConfirmarTrasladoInicio = false;
        this.TrasladoInicioCompanhia = "";
        this.TrasladoInicioVoo = "";
        this.mensagensErro = this.errorHandler(erro);
      }
    );
  }

  confirmarTrasladoOUT() {
    this.mensagensSucesso = [];
    this.mensagensErro = [];
    this.carregando = true;
    this.buscouValor = false;

    this.politicaCircuitoRQ.VooNumero = this.TrasladoFimVoo;
    this.politicaCircuitoRQ.TrasladoServicoId = this.TrasladoFim.ServicoId;

    this.circuitoService.trasladosCircuito(this.politicaCircuitoRQ).subscribe(
      dados => {
        this.carregando = false;
        this.liberaConfirmarTrasladoFim = false;
        this.confirmouTrasladoOUT = true;
        this.politicaCircuitoRS.Traslados = dados.Traslados;

        if (dados.Erros.length > 0) {
          this.mensagensErro = dados.Erros;
          this.TrasladoFimCompanhia = "";
          this.TrasladoFimVoo = "";
        }
        else {
          this.validarTraslados(dados.Traslados);
        }
      },
      erro => {
        this.carregando = false;
        this.liberaConfirmarTrasladoFim = false;
        this.TrasladoFimCompanhia = "";
        this.TrasladoFimVoo = "";
        this.mensagensErro = this.errorHandler(erro);
      }
    );
  }

  atualizarFlexivel(event) {
    if (event == false && this.politicaCircuitoRS.Abandonos[this.politicaCircuitoRS.Abandonos.length - 1].Data != this.DataAbandono || this.politicaCircuitoRS.Incorporacoes[0].Data != this.DataIncorporacao) {
      this.DataIncorporacao = this.politicaCircuitoRS.Incorporacoes[0].Data;
      this.CidadeIncorporacao = this.politicaCircuitoRS.Incorporacoes[0].CidadeNome
      this.DataAbandono = this.politicaCircuitoRS.Abandonos[this.politicaCircuitoRS.Abandonos.length - 1].Data;
      this.CidadeAbandono = this.politicaCircuitoRS.Abandonos[this.politicaCircuitoRS.Abandonos.length - 1].CidadeNome;
      this.confirmarFlexivel();
      this.noiteFim = 0;
      this.noiteInicio = 0;
      this.confirmouFlexivel = false;
      this.confirmouTrasladoIN = false;
      this.confirmouTrasladoOUT = false;
    }
    else {
      this.ref.detectChanges();
    }
  }

  atualizarNoitesAdicionais(event) {
    if (event == false && (this.noiteFim != 0 || this.noiteInicio != 0)) {
      this.politicaCircuitoRS.NoitesAdicionais.forEach((x) => {
        this.confirmarNoitesAdicionais(0, x);
      });
      this.noiteFim = 0;
      this.noiteInicio = 0;
      this.confirmouTrasladoIN = false;
      this.confirmouTrasladoOUT = false;
    }
    else {
      this.ref.detectChanges();
    }
  }

  exibirValor() {
    this.mensagensSucesso = [];
    this.mensagensErro = [];
    this.carregando = true;
    this.circuitoService.buscarValorFinalCircuito(this.politicaCircuitoRQ).subscribe(
      dados => {
        this.ValorProdutos = dados.Faturas;
        this.ValorProdutos.sort(function (a, b) { return b.ValorProduto - a.ValorProduto; });
        this.politicaCircuitoRS.ValorTotal = dados.ValorTotal;
        this.politicaCircuitoRS.Moeda = dados.Moeda;
        this.buscouValor = true;
        this.carregando = false;
      },
      erro => {
        this.mensagensErro = this.errorHandler(erro);
        console.log(erro);
        this.carregando = false;
        this.buscouValor = false;
        this.permiteReservar = false;
      }
    );
  }

  salvar(politica: boolean = false) {
    this.mensagensSucesso = [];
    this.mensagensErro = [];
    this.carregando = true;
    this.buscouValor = false;
    this.politicaCircuitoRQ.SalvarCircuito = true;
    this.politicaCircuitoRQ.ExtrasCircuito = this.infosCircuitoJSON();

    this.circuitoService.politicaCircuito(this.politicaCircuitoRQ).subscribe(
      dados => {
        this.politicaCircuitoRS.Circuito = dados.Circuito;
        this.alterou.emit(dados.Circuito);
        this.carregando = false;
        if (!politica) {
          this.mensagensSucesso.push("Esse procedimento salva apenas os dados do Valor do Circuito, das Noites Adicionais, dos Traslados e se o Circuito é Flexível.");
          this.mensagensSucesso.push("É necessário refazer todo o Processo se for Tarifar Novamente.");
        }
      },
      erro => {
        console.log(erro);
        this.carregando = false;
        this.mensagensErro = this.errorHandler(erro);
      });
  }

  // public confirmarReserva() {
  //   this.confirmacaoService.confirm('Confirmação de Reserva', 'Tem certeza que deseja Reservar o Circuito: ' + this.Circuito.Titulo, 'Reservar', 'Voltar', 'success')
  //     .then((confirmed) => {
  //       if (confirmed) {
  //         this.reservar();
  //       }
  //     })
  //     .catch(() => console.log(''));
  // }

  reservar() {
    if (confirm("Deseja reservar o circuito?")) {
      this.mensagensSucesso = [];
      this.mensagensErro = [];
      this.carregando = true;
  
      let reservarCircuitoRQ: ReservarCircuitoRQ = new ReservarCircuitoRQ();
  
      switch (this.Circuito.Fornecedor) {
        case "ST":
          reservarCircuitoRQ.ExtrasCircuito = this.infosCircuitoJSON();
      }
  
      reservarCircuitoRQ.Circuito = this.Circuito;
      reservarCircuitoRQ.Token = this.politicaCircuitoRQ.Token;
  
      this.circuitoService.reservarCircuito(reservarCircuitoRQ).subscribe(
        dados => {
          this.Circuito = dados.Circuito;
          this.reservado = true;
          this.alterou.emit(dados.Circuito);
          this.carregando = false;
        },
        erro => {
          this.mensagensErro = this.errorHandler(erro);
          console.log(erro);
          this.carregando = false;
        });
    }
  }

  validarTraslados(Traslados) {
    this.TrasladoInicio = new Traslado();
    this.TrasladoFim = new Traslado();

    if (Traslados != undefined) {
      Traslados.forEach(x => {
        if (x.TipoTraslado == "IN") {
          this.TrasladoInicio = x;
          this.TrasladoInicio.Existe = true;
        } else {
          this.TrasladoFim = x;
          this.TrasladoFim.Existe = true;
        }
      });
    };
  }

  infosCircuitoJSON() {
    let extraCircuito: InfosCircuito = new InfosCircuito();
    extraCircuito.CircuitoFlexivel = this.confirmouFlexivel;
    if (this.confirmouFlexivel) {
      extraCircuito.CidadeIncorporacao = this.CidadeIncorporacao;
      extraCircuito.CidadeAbandono = this.CidadeAbandono;
    }
    extraCircuito.TrasladoChegada = this.confirmouTrasladoIN;
    extraCircuito.TrasladoPartida = this.confirmouTrasladoOUT;
    extraCircuito.NoitesInicio = this.noiteInicio;
    extraCircuito.NoitesFim = this.noiteFim;
    let string: string = JSON.stringify(extraCircuito);
    return string;
  }

  public errorHandler(erro): string[] {
    let mensagem = [];
    switch (erro.status) {
      case 0: mensagem.push('o servidor não respondeu, tente novamente mais tarde!'); break;
      case 400:
        if (erro.error && erro.error.mensagem)
          mensagem.push(erro.error.mensagem);
        else
          mensagem.push("Houve algum erro na execução, tente novamente!");
        break;
      case 401: mensagem.push('você não tem autorização para executar esta ação!'); break;
      case 404: mensagem.push("Solicitação inválida!"); break;
      case 406: mensagem.push(erro.error.mensagem); break;
      case 500: mensagem.push('Houve um erro interno no servidor! tente novamente, caso o erro persista, entre em contato com o suporte'); break;
      default: mensagem.push(erro.statusText);
    }
    if (erro.error != null && erro.error.mensagens != null) {
      mensagem = [...mensagem, ...erro.error.mensagens];
    }
    return mensagem;
  }

  limparMensagens() {
    this.mensagensSucesso = [];
    this.mensagensErro = [];
  }

  fecharModal() {
    this.modalService.dismissAll();
  }

  limparMensagemTarifacao() {
    this.circuitoRetarifado = false;
    this.buscouValor = false;
  }
}
